import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import FormAdmissions from './components/FormAdmissions';

const Admissions = (props) => {
  return (<Container >
    <Row>
      <Col md={12}>
        <div className="title-general-section-icon-arrow-back">
          <h3>Admisiones</h3>
        </div>
      </Col>
    </Row>
    <FormAdmissions props={props} />
  </Container>)
};

export default Admissions;